"use client";

import { motion } from "framer-motion";
import Link from "next/link";
export function Header() {
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-border" data-unique-id="91ee6db5-90fa-4503-81b3-babfaee094c8" data-file-name="components/header.tsx">
      <div className="max-w-7xl mx-auto px-6 py-4" data-unique-id="4e5fb7c7-589e-4de2-ab55-ee689bbd50af" data-file-name="components/header.tsx">
        <div className="flex items-center justify-between" data-unique-id="e9dd7544-e2dc-4f89-b805-0bdb5b4df6bf" data-file-name="components/header.tsx" data-dynamic-text="true">
          {/* Logo */}
          <div className="flex items-center" data-unique-id="318c10e8-9da9-4030-8350-702fbe107ec2" data-file-name="components/header.tsx">
            <img src="https://pre-built-images.s3.amazonaws.com/webapp-uploads/3e1a1e8428c4467d3a044887e5601529.png" alt="Acumena - Strategic Management Assistant" className="h-10 w-auto" data-unique-id="6967b6b3-73fd-417c-acb5-d89b87d414b5" data-file-name="components/header.tsx" />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-unique-id="b7a95ce2-065c-4a09-863b-7b21201a2135" data-file-name="components/header.tsx">
            <Link href="#features" className="text-muted-foreground hover:text-foreground transition-colors duration-200 font-medium" data-unique-id="5f737a99-f1ca-49ea-a260-e353d4302297" data-file-name="components/header.tsx"><span className="editable-text" data-unique-id="115435b4-2dac-44f3-a36b-7bf281f55e5c" data-file-name="components/header.tsx">
              Features
            </span></Link>
            <Link href="#use-cases" className="text-muted-foreground hover:text-foreground transition-colors duration-200 font-medium" data-unique-id="18dd6a7b-98a2-412c-a3b5-a4a04b6a4b43" data-file-name="components/header.tsx"><span className="editable-text" data-unique-id="3f317ed3-1896-496c-85f4-7e2db9fa83c8" data-file-name="components/header.tsx">
              Use Cases
            </span></Link>
            <Link href="#pricing" className="text-muted-foreground hover:text-foreground transition-colors duration-200 font-medium" data-unique-id="f3aa123c-92dc-422a-b1f3-a538d361faec" data-file-name="components/header.tsx"><span className="editable-text" data-unique-id="03f1c321-f576-4a66-8dfc-400ba00b0f0e" data-file-name="components/header.tsx">
              Pricing
            </span></Link>
          </nav>

          {/* Launch App Button */}
          <Link href="https://system.acumena.my.id/" className="gradient-button text-primary-foreground px-6 py-2.5 rounded-lg font-semibold text-sm" data-unique-id="7f14bd8c-2fd1-4872-866c-288621ace9e9" data-file-name="components/header.tsx"><span className="editable-text" data-unique-id="ea05e966-4bff-4108-819f-bffdfc38a207" data-file-name="components/header.tsx">
            Launch App
          </span></Link>
        </div>
      </div>
    </motion.header>;
}